import React from 'react';
import { useNavigate } from 'react-router-dom';
import { cn } from '../lib/utils';
import type { Profile } from '../types/database';
import { supabase } from '../lib/supabase';

interface PostAuthorAvatarProps {
  profile: Profile | null | undefined;
  size?: 'sm' | 'md' | 'lg';
  onClick?: () => void;
}

export default function PostAuthorAvatar({ profile, size = 'md', onClick }: PostAuthorAvatarProps) {
  const navigate = useNavigate();

  const getAvatarUrl = () => {
    if (!profile) return `https://api.dicebear.com/7.x/initials/svg?seed=anonymous`;

    if (profile.avatar_url) {
      if (profile.avatar_url.startsWith('http')) {
        return profile.avatar_url;
      }
      const { data } = supabase.storage.from('avatars').getPublicUrl(profile.avatar_url);
      return data.publicUrl;
    }

    return `https://api.dicebear.com/7.x/initials/svg?seed=${profile.full_name}`;
  };

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else if (profile?.id) {
      navigate(`/user/${profile.id}`);
    }
  };

  const sizeClasses = {
    sm: 'h-8 w-8',
    md: 'h-10 w-10',
    lg: 'h-12 w-12'
  };

  return (
    <img
      src={getAvatarUrl()}
      alt={profile?.full_name || 'Anonymous'}
      className={cn(
        sizeClasses[size],
        "rounded-full object-cover bg-gray-100",
        profile?.id && "cursor-pointer hover:opacity-80"
      )}
      onClick={handleClick}
      onError={(e) => {
        const img = e.target as HTMLImageElement;
        img.src = `https://api.dicebear.com/7.x/initials/svg?seed=${profile?.full_name || 'anonymous'}`;
      }}
    />
  );
}